import { render, staticRenderFns } from "./sdkWallet.vue?vue&type=template&id=0cf727e2&"
import script from "./sdkWallet.vue?vue&type=script&lang=js&"
export * from "./sdkWallet.vue?vue&type=script&lang=js&"
import style0 from "./sdkWallet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports